import { PUBLIC_BETWATCH_API_ENDPOINT } from '$env/static/public';
import type { BookmakerMarketResponse } from '$types/races';

export async function fetchBookmakerMarket(
  f: typeof fetch,
  auth: { accessToken: string },
  id: string
) {
  const headers = {
    'Content-Type': 'application/json'
  } as Record<string, string>;
  if (auth.accessToken) {
    headers['Authorization'] = `Bearer ${auth.accessToken}`;
  } else {
    throw new Error('No auth provided');
  }
  const raceData = (await await f(PUBLIC_BETWATCH_API_ENDPOINT, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      query: `
        query GetBookmakerMarket($id: ID!) {
            bookmakerMarket(id: $id) {
              __typename
              id
              bookmaker
              fixedWin {
                flucs {
                  price
                  lastUpdated
                }
                openingPrice
                price
                lastUpdated
              }
              fixedPlace {
                flucs {
                  price
                  lastUpdated
                }
                openingPrice
                price
                lastUpdated
              }
            }
          }
        `,
      variables: {
        id
      }
    })
  })
    .then((res: Response) => res.json())
    .catch((err) => {
      console.error(err);
    })) as BookmakerMarketResponse;

  raceData?.data?.bookmakerMarket.fixedWin.flucs?.forEach((fluc) => {
    fluc.lastUpdated = new Date(fluc.lastUpdated);
  });

  raceData?.data?.bookmakerMarket.fixedPlace.flucs?.forEach((fluc) => {
    fluc.lastUpdated = new Date(fluc.lastUpdated);
  });

  if (raceData?.data) {
    raceData.data.bookmakerMarket.fixedWin.lastUpdated = new Date(
      raceData.data?.bookmakerMarket.fixedWin.lastUpdated
    );

    raceData.data.bookmakerMarket.fixedPlace.lastUpdated = new Date(
      raceData.data?.bookmakerMarket.fixedPlace.lastUpdated
    );
  }

  return raceData;
}
